export default "__VITE_ASSET__Bekm0x_C__"